import { type Agent } from './types.js'

export const agentsConfig = {
  agents: [
    {
      id: 'direct-agent',
      icon: '👤',
      name: 'Direct Messages',
      description: 'Personal emails from individuals and direct conversations.',
      emailTypes: ['direct'],
      internalLabel: 'direct',
      options: [
        {
          key: 'includeInSummary',
          type: 'boolean',
          default: true,
          label: 'Include in morning brief',
        },
      ],
    },
    {
      id: 'ticket-agent',
      icon: '🎫',
      name: 'Tickets & Events',
      description: 'Admission to something you attend — cinema, theater, concerts, and conferences.',
      emailTypes: ['ticket'],
      internalLabel: 'ticket',
      options: [
        {
          key: 'includeInSummary',
          type: 'boolean',
          default: true,
          label: 'Include in morning brief',
        },
      ],
    },
    {
      id: 'scheduling-agent',
      icon: '📅',
      name: 'Bookings & Invites',
      description: 'Meeting invites and booking confirmations — hotels, flights, restaurants, and appointments.',
      emailTypes: ['scheduling'],
      internalLabel: 'scheduling',
      options: [
        {
          key: 'includeInSummary',
          type: 'boolean',
          default: true,
          label: 'Include in morning brief',
        },
      ],
    },
    {
      id: 'receipt-agent',
      icon: '📦',
      name: 'Orders & Expenses',
      description: 'Order confirmations, shipping updates, delivery notifications, and purchase receipts.',
      emailTypes: ['receipt', 'order'],
      internalLabel: 'receipt',
      options: [
        {
          key: 'includeInSummary',
          type: 'boolean',
          default: true,
          label: 'Include in morning brief',
        },
      ],
    },
    {
      id: 'newsletter-agent',
      icon: '📰',
      name: 'Newsletters',
      description: 'Regular updates, news digests, and curated content.',
      emailTypes: ['newsletter'],
      internalLabel: 'newsletter',
      options: [
        {
          key: 'includeInSummary',
          type: 'boolean',
          default: true,
          label: 'Include in morning brief',
        },
      ],
    },
    {
      id: 'notifications-agent',
      icon: 'ℹ️',
      name: 'Notifications',
      description: 'Security alerts, terms updates, and service notifications.',
      emailTypes: ['security_alert', 'terms', 'notification'],
      internalLabel: 'notification',
      options: [
        {
          key: 'includeInSummary',
          type: 'boolean',
          default: true,
          label: 'Include in morning brief',
        },
      ],
    },
    {
      id: 'promotional-agent',
      icon: '🏷️',
      name: 'Promotional',
      description: 'Marketing emails, sales pitches, and discount offers.',
      emailTypes: ['promotional'],
      internalLabel: 'promotional',
      options: [
        {
          key: 'includeInSummary',
          type: 'boolean',
          default: true,
          label: 'Include in morning brief',
        },
      ],
    },
  ],
} as const satisfies { agents: Agent[] }

/**
 * Sender address of our own system daily brief emails. The user receives these
 * from their own product, so they must never be analysed.
 *
 * email-sync skips it at Gmail ingest (its own `DAILY_BRIEF_SENDER` constant);
 * the email-agent poller uses this mirror to skip it for every Stalwart
 * message, including native SMTP delivery.
 * Lowercase — compare against a lowercased address.
 */
export const DAILY_BRIEF_SENDER = 'brief@langmail.me'

export type AgentId = (typeof agentsConfig.agents)[number]['id']

export function getAllAgentIds(): readonly AgentId[] {
  return agentsConfig.agents.map((a) => a.id)
}
